import { render } from "./bankAccount.vue?vue&type=template&id=86d996b4&scoped=true"
import script from "./bankAccount.vue?vue&type=script&lang=js"
export * from "./bankAccount.vue?vue&type=script&lang=js"

import "./bankAccount.vue?vue&type=style&index=0&id=86d996b4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86d996b4"]])

export default __exports__